import { render } from "./TextInputComp.vue?vue&type=template&id=5ffac717&scoped=true"
import script from "./TextInputComp.vue?vue&type=script&lang=js"
export * from "./TextInputComp.vue?vue&type=script&lang=js"

import "./TextInputComp.vue?vue&type=style&index=0&id=5ffac717&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffac717"]])

export default __exports__